import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 768,
      padding: theme.spacing(2),
    },
    modalWrap: {
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    topTitle: {
      fontSize: '20px',
      fontWeight: 500,
      flex: 1,
    },
    sectionTitle: {
      fontSize: '14px',
      fontWeight: 500,
    },
    storyInfoBox: {
      display: 'flex',
      alignContent: 'top',
    },
    storyDetailBox: {
      '& >div': {
        marginBottom: 6,
      },
    },
    coverImage: {
      width: 160,
      height: 90,
      marginRight: 10,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    addRelatedStoryPopup: {
      width: 700,
      height: 500,
    },
    segmentSelect: {},
    mapperDetailForm: {
      height: 280,
    },
    segmentSelectorWrap: {
      display: 'flex',
      flexDirection: 'column',
      height: '140px',
    },
    addButtonContainer: {
      textAlign: 'center',
      padding: theme.spacing(2),
    },
    mapperTypeContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(1),
    },
    segmentContainer: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    segmentTitle: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      backgroundColor: '#EFEFEF',
    },
    storyLabel: {
      display: 'inline-block',
      width: 60,
      fontWeight: 500,
      marginRight: 10,
    },
    segmentLabel: {
      fontWeight: 500,
      marginRight: 10,
    },
    segmentName: {
      fontWeight: 500,
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
    noData: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(3),
      textAlign: 'center',
      fontWeight: 500,
    },
    formLabel: {
      fontWeight: 500,
      fontSize: 14,
    },
    relatedStoryTitle: {
      color: theme.palette.text.primary,
    },
  }),
);

export default useStyles;
